define(
    'views/secured/explorer/navigation/navigation.html',[
        "durandal/system",
        "jquery",
        "ace"
    ],
    function(system, $, ace) {

        var vm = {
        };

        vm.attached = function (viewModel, viewHtml) {
            ace.handle_side_menu($);
            // note: the drop down menu options currently do not cross over the west pane in the jquery.layout so 
            // overflow control isn't required - yet. if we have sub-menus we may need this functionality.
            handleDropDownOverflows();

            //$("#explorer-navigation").draggable({
            //    drag: function (event, ui) { return false; }
            //});
        };

        return vm;

        // note: this is the dodgiest code ever. 
        // aims to allow drop down menues to cross jquery layout panes when they are opened. resets overwise.
        function handleDropDownOverflows() {
            if (kendo.support.mobileOS) {
                var overflowIsOn = false;

                var handler = function (args) {
                    if (overflowIsOn) {
//                      fp.explorerLayout.resetOverflow('west');
                        $("#explorer-navigation").css("-webkit-overflow-scrolling", "touch"); // note: this allows the momentum scrolling in ios but interferes with document flow and the dropdown overlays.
                        overflowIsOn = false;
                    } else {
//                      fp.explorerLayout.allowOverflow('west');
                        $("#explorer-navigation").css("-webkit-overflow-scrolling", "");
//                      $('<style></style>').appendTo($(document.body)).remove(); // note: dodge workaround - forces webkit to redraw scrollbar space - http://stackoverflow.com/a/5258893
                        overflowIsOn = true;
                    }
                };


                // temporarily allow popup menus to cross over jquery layout panes.
                $(document).on("click", "[data-toggle=dropdown]", function(args) {
                    handler(args);
                });

                $(document).on("click", function(args) {
                    overflowIsOn = true;
                    handler(args);
                });
            }
        }
    });
